import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, SubmitButton, FormError } from "@/components/forms/Field";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword({ mode = "reset" }) {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const setup = mode === "setup";

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords do not match");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token") || "", password });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={setup ? "Set your password" : "Choose a new password"} subtitle={setup ? "Welcome to Disha. Choose a password to activate your account." : "Use at least 8 characters with a letter and a number."}>
      {done ? (
        <div className="card-surface p-8 text-center" data-testid="reset-password-success">
          <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto" />
          <p className="mt-4 font-display text-xl font-bold">{setup ? "Your account is active." : "Password updated."}</p>
          <Link to="/login" className="btn-pill mt-6 inline-flex items-center bg-ds-plum text-white hover:bg-[#3d0232]" data-testid="reset-go-login">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-password-form">
          <Field id="password" label="New password" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} testId="reset-password-input" />
          <Field id="confirm" label="Confirm password" type="password" autoComplete="new-password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} testId="reset-confirm-input" />
          <FormError message={error} testId="reset-error" />
          <SubmitButton busy={busy} testId="reset-submit-button">{setup ? "Activate account" : "Update password"}</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
